import { MyFortAgentItem } from "@/api/types";
import agentImage from "@/assets/images/agent-dark-bg-aif.png";
/** 静态收益进度百分比（0-100） */
export function calcAgentProgressPct(agent: MyFortAgentItem): number {
  return BigInt(agent.staticCapUsdt || "0") > 0n
    ? Math.min(
        100,
        Number(
          (BigInt(agent.staticPaidUsdt || "0") * 100n) /
            BigInt(agent.staticCapUsdt)
        )
      )
    : 0;
}

/** AIF 释放进度百分比（0-100） */
export function calcAifProgressPct(agent: MyFortAgentItem): number {
  return agent.aifDistributeDays > 0
    ? (agent.aifPaidDays / agent.aifDistributeDays) * 100
    : 0;
}

/** 与 forttrade-dapp 市场卡头像一致 */
export const AGENT_IMAGE_URL = agentImage;
